import React from 'react';
import { DragDropContext as dragDropContext } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import toClass from 'recompose/toClass';
import BodyStyle from '../containers/BodyStyle';
import DeviceOrientation from '../containers/DeviceOrientation';
import DocumentHead from '../containers/DocumentHead';
import EmbedlySizer from '../containers/EmbedlySizer';
import ImageReloader from '../containers/ImageReloader';
import Project from '../containers/Project';
import CustomDragLayer from './CustomDragLayer';
// import { isMobile } from '../utils/deviceDetection';
import GlobalStyle from './GlobalStyle';
// TODO: re-enable DevTools
// Include redux DevTools on development
// (if redux-devtools-extension is not installed)
// https://github.com/zalmoxisus/redux-devtools-extension
var DevTools;
// if (
//   process.env.NODE_ENV === 'development' &&
//   !window.__REDUX_DEVTOOLS_EXTENSION__ &&
//   !process.env.NO_DEV_TOOLS &&
//   !isMobile // DevTools slow down the player on mobile devices (and cannot be toggled)
// ) {
//   // eslint-disable-next-line global-require
//   DevTools = require('../containers/DevTools').default;
// }
// TODO: use something like https://github.com/nrako/react-component-resizable
// and dispatch an action when <App /> is resized
function App() {
    return (React.createElement("div", { className: "height-100 width-100 position-relative" },
        React.createElement(GlobalStyle, null),
        React.createElement(DocumentHead, null),
        React.createElement(BodyStyle, null),
        React.createElement(DeviceOrientation, null),
        process.env.NODE_ENV !== 'test' && React.createElement(ImageReloader, null),
        React.createElement(EmbedlySizer, null),
        React.createElement(CustomDragLayer, null),
        React.createElement(Project, null),
        DevTools && React.createElement(DevTools, null)));
}
export default dragDropContext(HTML5Backend)(toClass(App));
